module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-bookmark-d4b5bef2.svg";